import axois from "axios";
import { BaseApiService } from "./api-base";

export class GmcApiService extends BaseApiService {
  constructor(host: string) {
    super("gmc");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  get(method: string, params: any = undefined) {
    const path = `${this.url}/${method}`;
    return this.http.get(path, { params }).then((response) => response.data);
  }

  post(method: string, body: any = undefined) {
    const path = `${this.url}/${method}`;
    return this.http.post(path, body).then((response) => response.data);
  }

  get_imgs() {
    const method = "conts";
    return this.get(method);
  }

  get_buckets(data: { prefix: any }) {
    const method = "m_buckets";
    const params = data;
    return this.get(method, params);
  }

  get_folders(data: { img: any; bucket: any }) {
    const method = "folders";
    const body = data;
    return this.post(method, body);
  }

  set_new_folder(data: { folder: any; bucket: any; name: any }) {
    const method = "reload_net";
    const body = {
      in: data.folder,
      bucket: data.bucket,
      name: data.name,
    };
    return this.post(method, body);
  }

  revert_model(data: { name: any }) {
    const method = "revert_net";
    const body = data;
    return this.post(method, body);
  }

  clear_cache() {
    const method = "clear_cache";
    const body = {
      app_ref: this.app_ref,
    };
    return this.post(method, body);
  }

  // TODO: this.post
  get_current_folder(data: { path: string }) {
    data.path = `api${data.path}current_model`;
    return this.http.post(data.path).then((response) => response.data);
  }

  // TODO: this.post
  predict_batch(data: {
    path: any;
    questions: any;
    prob_border: any;
    is_arr: any;
  }) {
    data.path = `api${data.path}predict_batch`;
    const body = data.is_arr
      ? data.questions
      : {
          questions: data.questions,
          prob_border: parseFloat(data.prob_border) || 0,
        };
    return this.http.post(data.path, body).then((response) => response.data);
  }
}
